import { reportError } from '../reportError';

/**
 * @deprecated Use `reportError` with an `Error` instance so the report carries a real
 * stack. Kept as a shim so existing callers produce the same RUM custom error on every
 * platform (previously a Datadog *log* on native, which Error Tracking never sees).
 */
export const logError = async (message: string, context?: Record<string, unknown>) => {
  await reportError(new Error(message), { context });
};
